import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#uc_svg__a)' rx={9.5} />
    <defs>
      <pattern id='uc_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#uc_svg__b' transform='scale(.00333)' />
      </pattern>
      <image xlinkHref='/images/icons/uc-3c7fa93a.webp' id='uc_svg__b' width={300} height={300} />
    </defs>
  </svg>
);
export default SvgUc;
